import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Query {
  event_id: string;
  cover_image: string;
}
/**
 * 后端灰度开启开关列表（比如草稿箱列表传"list_draft"、创建活动传"create_event"）
 */
export type GraySwitch = string[];
export interface UpdateCoverRes {
  msg: string;
  code: number;
  nonce: string;
  data: boolean;
}

const UpdateCoverImage = (data: Query, ctx?: GetServerSidePropsContext) => http.post<UpdateCoverRes>(
  '/wemeet-tapi',
  '/v2/activities/dashboard/register/update-cover-image',
  data,
  ctx,
);

export default UpdateCoverImage;
